export const AccessToken = {
    value: null as (string | null),
    expires: null as (Date | null)
}